import { DataModel, DataModel2 } from "generated/openApi";

export const defaultDataModel: DataModel = {
  id: 0,
  touched: true,
  hardDeleted: false,
  deleted: false,
  displayOrder: undefined,
  isLocked: false,
  isNotUi: false,
};

// use this instead if there are alot of required fields that you don't want to manually set
export const initDataModel = <T extends DataModel>(dataModel?: Partial<T>): T => {
  const defaultObject: DataModel = {
    id: 0,
    touched: true,
    hardDeleted: false,
    deleted: false,
    displayOrder: undefined,
    isLocked: false,
    isNotUi: false,
  };

  return {
    ...defaultObject,
    ...dataModel,
  } as T;
};

export const defaultDataModel2: DataModel2 = {
  id: 0,
  touched: true,
  hardDeleted: false,
  deleted: false,
};

export const initDataModel2 = <T extends DataModel2>(dataModel?: Partial<T>): T => {
  const defaultObject: DataModel2 = {
    id: 0,
    touched: true,
    hardDeleted: false,
    deleted: false,
  };

  return {
    ...defaultObject,
    ...dataModel,
  } as T;
};
